import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    borderStyle: 'solid',
    backgroundColor: 'white',
    padding: '0 15px',
    rounded: 'main',
    height: '48px',
    minWidth: '48px',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',

    outline: 'none',

    fontSize: '15px',
    fontWeight: 400,
    letterSpacing: '0.15px',
    fontFamily: 'acBase',
    color: 'grey.dark.2',

    transitionDuration: 'slow',
    transitionBehavior: 'linear',
    transitionProperty: 'border, background-color, box-shadow, color',

    wordBreak: 'keep-all',

    textDecoration: 'none',

    flexShrink: 0,

    _active: {
      borderColor: 'grey.dark.2',
    },

    _open: {
      borderColor: 'grey.dark.2',
    },
  },
  variants: {
    size: {
      compact: {
        height: '30px',
        padding: '0 0.5rem',
        borderRadius: 'small',
        fontSize: '13px',
      },
      smaller: {
        height: '32px',
        minWidth: '32px',
      },
      small: {
        height: '40px',
        minWidth: '40px',
      },
      medium: {
        height: '48px',
        minHeihght: '48px',
      },
    },
    variant: {
      outline: {
        borderColor: 'grey.light.3',
        borderWidth: '1px',

        _hover: {
          backgroundColor: 'grey.blue.1',
          borderColor: 'grey.dark.2',
          // boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.1)',
          boxShadow: '10px 10px 15px 0px rgba(17, 17, 17, 0.02)',
        },

        _disabled: {
          borderColor: 'grey.light.2',
          color: 'grey.light.2',
          cursor: 'disabled',
        },
      },
      ghost: {
        border: 'none',
        backgroundColor: 'transparent',
        color: 'grey.light.3',

        '& svg': {
          stroke: 'grey.light.3',

          transitionProperty: 'stroke',
          transitionDuration: 'slow',
          transitionBehavior: 'linear',
        },

        _hover: {
          color: 'grey.dark.2',
          '& svg': {
            stroke: 'grey.dark.2',
          },
        },
        _open: {
          color: 'grey.dark.2',
          '& svg': {
            stroke: 'grey.dark.2',
          },
        },
        _active: {
          color: 'grey.dark.2',
          '& svg': {
            stroke: 'grey.dark.2',
          },
        },

        _disabled: {
          color: 'grey.light.2',
          '& svg': {
            stroke: 'grey.dark.2',
          },
        },
      },
      'ghost-dark': {
        backgroundColor: 'transparent',
        border: 'none',

        '& svg': {
          stroke: 'grey.dark.1',

          transitionProperty: 'stroke',
          transitionDuration: 'slow',
          transitionBehavior: 'linear',
          _hover: {
            stroke: 'grey.dark.2',
          },
          _open: {
            stroke: 'grey.dark.2',
          },
          _active: {
            stroke: 'grey.dark.2',
          },
        },
      },
      icon: {
        color: 'grey.light.3',
        border: 'none',
        transitionProperty: 'color',
        transitionDuration: 'slow',
        transitionBehavior: 'linear',
        backgroundColor: 'transparent',
        fontSize: '22px',

        width: '20px',
        height: '20px',

        _hover: {
          color: 'grey.dark.2',
        },
      },
      dim: {
        color: 'grey.light.2',
        transitionProperty: 'border, background-color, box-shadow, color',
        borderStyle: 'none',

        background: 'none',

        _hover: {
          color: 'grey.dark.2',
        },
      },
      user: {
        borderColor: 'grey.light.1',
        backgroundColor: 'grey.light.0',
        borderWidth: 1,

        _hover: {
          borderColor: 'grey.dark.2',
        },

        _open: {
          borderColor: 'grey.dark.2',
        },
      },
      inset: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: 'main',
        borderColor: 'grey.light.1',
        backgroundColor: 'grey.light.0',
        color: 'grey.dark.2',

        height: '48px',

        fontSize: '15px',
        fontWeight: 400,
        letterSpacing: '0.15px',

        _hover: {
          borderColor: 'grey.dark.2',
        },
        _open: {
          borderColor: 'grey.light.1',
        },
      },
      nav: {
        cursor: 'pointer',
        borderColor: 'grey.light.1',
        borderWidth: '1px',

        height: '32px',
        borderRadius: 'smaller',

        padding: '0px 10px',

        minWidth: '140px',

        justifyContent: 'space-between',

        textTransform: 'capitalize',

        textDecoration: 'none',

        '& > span': {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          maxWidth: 'calc(100% - 24px)',
        },

        _hover: {
          backgroundColor: 'grey.blue.1',
          borderColor: 'grey.light.3',
          // boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.1)',
          boxShadow: '10px 10px 15px 0px rgba(17, 17, 17, 0.02)',
        },

        _selected: {
          borderColor: 'grey.dark.2 !important',
        },

        _disabled: {
          borderColor: 'grey.light.1',
          color: 'grey.light.2',
          cursor: 'disabled',
        },
      },
      'nav-plain': {
        cursor: 'pointer',
        border: 'none',
        textDecoration: 'none',
        justifyContent: 'flex-start',

        height: '30px',

        borderLeftRadius: 0,
        color: 'grey.dark.2',
        fontSize: '16px',

        borderLeftStyle: 'solid',
        borderLeftWidth: '0px',
        borderLeftColor: 'halton.blue',

        padding: '0px 15px 0px 15px',

        transitionDuration: 'faster',
        transitionProperty: 'color, background-color, border-left-radius, border-left-width, font-weight',
        backgroundColor: 'transparent',

        _hover: {
          backgroundColor: 'halton.green/10',
          cursor: 'pointer',
        },

        _open: {
          borderLeftWidth: '5px',
          borderLeftRadius: 0,
          borderLeftColor: 'halton.blue',

          cursor: 'pointer',

          fontWeight: 600,
        },
      },
    },
    iconSize: {
      medium: {
        '& svg': {
          width: '1rem',
          height: '1rem',
        },
      },
      large: {
        '& svg': {
          width: '1.2rem',
          height: '1.2rem',
        },
      },
      xlarge: {
        '& svg': {
          width: '1.5rem',
          height: '1.5rem',
        },
      },
    },
    floating: {
      true: {
        boxShadow: '8px 8px 8px 0px rgba(17, 17, 17, 0.05) !important',
      },
    },
    iconHover: {
      normal: {
        '& svg': {
          transitionProperty: 'stroke',
          transitionDuration: 'slow',
          transitionBehavior: 'linear',
          stroke: 'grey.light.2',

          _hover: {
            stroke: 'grey.dark.2',
          },
        },
      },
    },
    selectedIcon: {
      true: {
        '& > svg': {
          transitionProperty: 'opacity',
          transitionDuration: 'slow',
          transitionBehavior: 'linear',
          opacity: 0,
        },
        _selected: {
          '& > svg': {
            opacity: 1,
          },
        },
      },
    },
  },
  defaultVariants: {
    size: 'medium',
    variant: 'outline',
    iconSize: 'medium',
  },
});
